@if(items?.length){

<div [ngStyle]="isIcms ? {'min-height' : '50px'} : {}">
    <ul>
        @for(item of items; track item.label){
        <li class="flex flex-middle"
            [ngClass]="{'m-t-2' : !$first}">
            <span class="s1 m-r-1">{{item.label}}:</span><span class="p1">{{item.options}}</span>
        </li>
        }
    </ul>
</div>
}